import { render, staticRenderFns } from "./WorkPermitTableBody.vue?vue&type=template&id=648c7e4b&scoped=true&"
import script from "./WorkPermitTableBody.vue?vue&type=script&lang=js&"
export * from "./WorkPermitTableBody.vue?vue&type=script&lang=js&"
import style0 from "./WorkPermitTableBody.vue?vue&type=style&index=0&id=648c7e4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648c7e4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('648c7e4b')) {
      api.createRecord('648c7e4b', component.options)
    } else {
      api.reload('648c7e4b', component.options)
    }
    module.hot.accept("./WorkPermitTableBody.vue?vue&type=template&id=648c7e4b&scoped=true&", function () {
      api.rerender('648c7e4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/WorkPermitTableBody.vue"
export default component.exports